import { render, staticRenderFns } from "./accurateInfo.vue?vue&type=template&id=23e507be&scoped=true"
import script from "./accurateInfo.vue?vue&type=script&lang=js"
export * from "./accurateInfo.vue?vue&type=script&lang=js"
import style0 from "./accurateInfo.vue?vue&type=style&index=0&id=23e507be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e507be",
  null
  
)

export default component.exports